const $ = jQuery.noConflict();

class ShowItemOnScroll {
    constructor(hiddenItem) {
        this.hiddenItem = hiddenItem;
    }
    init() {
        if($(window).scrollTop() > 0) {
            $(this.hiddenItem).addClass('visible');
        }
        else {
            $(this.hiddenItem).removeClass('visible');
        }
    }

}

export default new ShowItemOnScroll('.addtoany-content');